import React, { Component } from 'react';
import classnames from "classnames";

import "./index.scoped.sass";
import { record } from "@/services/http";
import PlateList from "@/components/PlateList";

export default class Record extends Component {
    constructor(props) {
        super(props);

        this.state = {
            inputLP: "",
            valiLP: true,
            licencePlateArr: this.getLicencePlate(),
            ajaxRes: [],
        };
        this.longPressTimer = -1;
        this.opener = "";
        this.isOnComposition = false;
    }

    componentDidMount() {
        this.opener = new window.mdui.Dialog(this.dialog, {
            history: false,
        });
        if (this.state.licencePlateArr.length == 0) {
            this.opener.open();
        }
    }


    getLicencePlate() {
        let arr = localStorage.licencePlateArr;
        try {
            return JSON.parse(arr);
        } catch (error) {
            return [];
        }
    }

    inputLicencePlate = (e) => {
        const v = e.target.value.trim();
        this.setState({
            inputLP: v,
            valiLP: isLicensePlate(v),
        });
    }
    addLicencePlate = () => {
        if (!this.state.valiLP) return;
        const v = this.state.inputLP.replace(/\s/g, '').toUpperCase();
        let lpArr = [...this.state.licencePlateArr];
        // 重复车牌处理
        lpArr = lpArr.filter(p => p != v);
        lpArr.push(v);
        this.setState({
            licencePlateArr: [...lpArr],
        }, () => {
            this.setState({
                inputLP: '',
            });
            localStorage.licencePlateArr = JSON.stringify(lpArr);
        });
        this.opener.close();
    }
    delLicencePlate = (index) => {
        let arr = this.state.licencePlateArr;
        arr.splice(index, 1);
        this.setState({
            licencePlateArr: arr,
        }, () => {
            localStorage.licencePlateArr = JSON.stringify(arr);
        });
    }
    ajaxRecord = (licencePlate) => {
        record({ licencePlate }).then((res) => {
            if (res.data.code != 200) throw new Error(res.data.msg);
            this.setState({
                ajaxRes: res.data.result,
            });
        }).catch((err) => {
            window.mdui.snackbar({
                message: err.message,
            });
        });
    }

    render() {
        const { valiLP, licencePlateArr } = this.state;
        return (
            <div id="Record">
                <div className="tips">
                    <p>由于一些技术问题</p>
                    <p>当前功能仅部分车牌可用</p>
                    <p>有感兴趣的 Android、IOS 大神请联系我</p>
                </div>
                <PlateList listArr={licencePlateArr} clickPlate={this.ajaxRecord} delItem={this.delLicencePlate} />
                <div className="mdui-dialog dialog" ref={(elm) => { this.dialog = elm; }}>
                    <div className="mdui-dialog-title">添加车牌</div>
                    <div className="mdui-dialog-content">
                        <div className="mdui-col">
                            <div className={classnames("mdui-textfield", { "mdui-textfield-invalid": !valiLP })}>
                                <div className="mdui-textfield-error">车牌输入错误</div>
                                <i className="mdui-icon material-icons">directions_car</i>
                                <input className="mdui-textfield-input" type="text" placeholder="请输入车牌" required="required" value={this.state.inputLP} onChange={e => this.inputLicencePlate(e)} />
                            </div>
                        </div>
                    </div>
                    <div className="mdui-dialog-actions">
                        <button className="mdui-btn mdui-ripple" mdui-dialog-cancel="true">取消</button>
                        <button className={classnames("mdui-btn mdui-ripple submit", { disable: !valiLP })} onClick={this.addLicencePlate}>确定</button>
                    </div>
                </div>
                <button className="mdui-fab mdui-fab-mini mdui-color-theme-accent mdui-ripple fltBtn"
                    onClick={() => { this.opener.open(); }}
                ><i className="mdui-icon material-icons">add</i></button>
                {
                    this.state.ajaxRes.length != 0 ?
                        <div className="show">
                            {this.state.ajaxRes.map(v => (
                                <div key={v.orderId}>
                                    <p><span className="title">车牌:</span>{v.licencePlate}</p>
                                    <p><span className="title">停车地点:</span>{v.parkingArea}</p>
                                    <p><span className="title">停车时长:</span>{v.duration}分</p>
                                    <p><span className="title">进入时间:</span>{new Date(Number(v.inTime)).toLocaleString()}</p>
                                    <p><span className="title">离开时间:</span>{new Date(Number(v.outTime)).toLocaleString()}</p>
                                    <p><span className="title">折扣:</span>{v.discount}折</p>
                                    <p><span className="title">费用:</span>{v.shouldpay}元</p>
                                    <hr />
                                </div>
                            ))}
                            <button className="mdui-fab mdui-fab-mini mdui-color-theme-accent mdui-ripple fltBtn"
                                onClick={() => { this.setState({ ajaxRes: '' }); }}
                            ><i className="mdui-icon material-icons">close</i></button>
                        </div>
                        : null
                }
            </div>
        );
    }
}



function isLicensePlate(str) {
    str = str.replace(/\s/g, '').toUpperCase();
    return /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/.test(str);
}
